var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.585 3.52581L18.585 1.77581C18.41 1.73206 18.2175 1.74956 18.0512 1.81956L9.56375 5.21456L2.835 3.52581C2.37125 3.41206 1.89 3.70081 1.77625 4.16456C1.75875 4.23456 1.75 4.30456 1.75 4.37456V23.6246C1.75 24.0271 2.02125 24.3771 2.415 24.4733L9.415 26.2233C9.485 26.2408 9.555 26.2496 9.625 26.2496C9.73875 26.2496 9.84375 26.2321 9.94875 26.1883L18.4362 22.7933L25.165 24.4733C25.6287 24.5958 26.1012 24.3071 26.2237 23.8433C26.2412 23.7733 26.25 23.7033 26.25 23.6246V4.37456C26.25 3.98081 25.9788 3.63081 25.585 3.52581ZM8.75 24.2546L3.5 22.9421V5.50331L8.75 6.81581V24.2546ZM17.5 21.2883L10.5 24.0883V6.71955L17.5 3.91956V21.2883ZM24.5 22.5046L19.25 21.1921V3.75331L24.5 5.06581V22.5046Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMap);
export default __webpack_public_path__ + "static/media/ic-map.5b17e670465dd48c6f7ee6dfa046d689.svg";
export { ForwardRef as ReactComponent };